<template>
    <div id="app">
        <header-partial />
        <navigation-bar />

        <!-- route outlet -->
        <main class="py-4">
            <flash-notice />
            <router-view></router-view>
        </main>

        <footer-partial />
    </div>
</template>

<script>
import HeaderPartial from './components/Partials/HeaderPartial.vue'
import NavigationBar from './components/Partials/NavigationPartial.vue'
import FooterPartial from './components/Partials/FooterPartial.vue'
import FlashNotice  from './components/Util/FlashNotice.vue'

import AuthService from './services/AuthService'

export default {
    name: 'App',
    components: {
        HeaderPartial,
        NavigationBar,
        FooterPartial,
        FlashNotice,
    },
    created(){
        this.$store.dispatch('forces/fetch');
        this.$store.dispatch('ranks/load');
    },
    mounted() {
        this.sessionCheck();
        window.addEventListener('focus', this.sessionCheck);
    },
    methods: {
        sessionCheck: function () {
            AuthService.session()
                .then(({data}) => this.success(data))
                .catch(error => this.failed(error));
        },
        success: function (data) {
            if (data.logged_in_user !== null) {
                this.$store.commit('login', data);
            } else {
                this.$store.commit('logout');
            }
        },
        failed: function (error) {
            if (typeof error.response.data === 'object') {
                // TODO:
                // form.errors = _.flatten(_.toArray(error.response.data.errors));
            } else {
                // TODO:
                // form.errors = ['Something went wrong. Please try again.'];
            }
        }
    }
}
</script>
